// SmbMateProcessorNotice — say whose name Stripe is about to show, before the redirect.
//
// WHY. Both brands run through ONE Stripe platform account, so an SMBMate contractor is sent
// to a Stripe page headed "TradesMatePro" — a company they have never heard of, at the exact
// moment they are being asked for bank details. Operator ruling 2026-09-05: disclose it.
//
// WHY IT IS A COMPONENT. The notice was written once, inside StripeConnectSettings, and the
// onboarding Go Live step has its own "Set Up Card Payments" button that redirects to the
// same place with no disclosure at all. Reported live on smbmate.com: the contractor went
// through onboarding, not Settings, and met the TradesMatePro name cold.
//
// Duplicating the text would also have duplicated STRIPE_PLATFORM_NAME, which is exactly the
// two-homes-for-one-fact problem that makes copy drift apart. Every redirect point renders
// this, so there is one wording and one platform name.

import React from 'react';
import { useBrand } from '../../contexts/BrandContext';

// The Stripe platform account both brands connect through; this is the name Stripe displays.
export const STRIPE_PLATFORM_NAME = 'TradesMatePro';

const SmbMateProcessorNotice = ({ className = 'mb-3' }) => {
  const { brand, isSmbMate } = useBrand();
  if (!isSmbMate) return null;

  return (
    <div className={`${className} rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-200`}>
      Payments are processed by <strong>{STRIPE_PLATFORM_NAME}</strong>, the company behind{' '}
      {brand?.name || 'SMBMate'}. Stripe's secure setup page will show that name — this is expected,
      and your own customers only ever see your business name.
    </div>
  );
};

export default SmbMateProcessorNotice;
